import restApi from "@plannel/services/utils/rest-api";

const get = () => {
  return restApi.get("/api/data-transform");
};

const transform = (data) => {
  return restApi.post("/api/data-transform/transform", data);
};

const transformDP = data => {
  return restApi.post("/api/data-transform/transform/dp", data);
};

const dataTransformService = {
  get,
  transform,
  transformDP
};

export default dataTransformService;